import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import {
  applicationStageMap,
  applicationStatusMap,
} from "../../config/applicationStatusConfig";

const UserPendingApplications = () => {
  const includedStatuses = [
    "incompleteDocumentPending",
    "incompleteInformation",
    "dlctUnverified",
  ];

  const statuses = Object.entries(applicationStatusMap)
    .filter(([key]) => includedStatuses.includes(key))
    .map(([, value]) => value.value);

  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="User Pending Applications"
        status={statuses}
        stage={[applicationStageMap?.user.value]}
      />
    </DashboardLayout>
  );
};

export default UserPendingApplications;
